import { ready } from './utilities';

ready(initMonthlyTradeActivity);

function initMonthlyTradeActivity() {
  const chart = document.querySelector('.monthly-trade-activity__chart');
  if (!chart) return;

  const months = Array.from(chart.querySelectorAll('.monthly-trade-activity__month'));
  if (months.length === 0) return;

  const closeAllTooltips = () => {
    months.forEach((month) => {
      const tooltip = month.querySelector('.monthly-trade-activity__tooltip');
      if (!tooltip) return;
      tooltip.classList.remove('monthly-trade-activity__tooltip--visible', 'monthly-trade-activity__tooltip--floating');
      tooltip.style.left = '';
      tooltip.style.top = '';
    });
  };

  const openTooltip = (month) => {
    const tooltip = month.querySelector('.monthly-trade-activity__tooltip');
    if (!tooltip) return;

    closeAllTooltips();

    tooltip.classList.add('monthly-trade-activity__tooltip--floating', 'monthly-trade-activity__tooltip--visible');

    const monthRect = month.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const margin = 8;

    let left = monthRect.left + (monthRect.width / 2) - (tooltipRect.width / 2);
    left = Math.max(margin, Math.min(left, window.innerWidth - tooltipRect.width - margin));

    let top = monthRect.bottom + margin;
    if (top + tooltipRect.height > window.innerHeight - margin) {
      top = monthRect.top - tooltipRect.height - margin;
    }
    top = Math.max(margin, Math.min(top, window.innerHeight - tooltipRect.height - margin));

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  };

  months.forEach((month) => {
    month.addEventListener('mouseenter', () => {
      openTooltip(month);
    });

    month.addEventListener('mouseleave', () => {
      closeAllTooltips();
    });

    month.addEventListener('click', (event) => {
      event.stopPropagation();
      const tooltip = month.querySelector('.monthly-trade-activity__tooltip');
      if (!tooltip) return;

      const isOpen = tooltip.classList.contains('monthly-trade-activity__tooltip--visible');
      if (isOpen) {
        closeAllTooltips();
      } else {
        openTooltip(month);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.monthly-trade-activity__month')) {
      closeAllTooltips();
    }
  });

  window.addEventListener('resize', closeAllTooltips);
  window.addEventListener('scroll', closeAllTooltips, true);
}
